export const enum RequestStatus {
  Initial = 'initial',
  Pending = 'pending',
  Done = 'done',
  Error = 'error',
}

export type ListResults<T> = {
  count: number
  next: string | null
  previous: string | null
  results: Array<T>
}

export type ListData<T> = {
  count: number
  next: string | null
  previous: string | null
  data: Array<T>
}

export type Data<T> = {
  data: T
}

export type ServerError = {
  error: string
  error_description: string
  errors: {
    [key: string]: Array<string>
  }
}
